import Form from '../04-components/form';
import { get as getPageOptions } from '../01-helpers/utilities/options';

const module = 'reject-scorecard-form',
    selector = {
        base: `.js-${module}`
    };

export default class RejectScorecardForm extends Form {

    constructor(baseElement) {
        super(baseElement);

        this.data = getPageOptions('scorecard');
    }

    onSubmitHandler(ev) {
        if (this.$form.valid()) {
            dataLayer.push({
                'event': 'scorecard_declined_motivated',
                'course': this.data.CourseName,
                'holes': this.data.LoopName,
                'tee': this.data.TeeName,
                'Qualifying': this.data.IsQualifying,
                'eventCategory': 'scoreCard',
                'eventAction': 'check',
                'eventLabel': 'declined_motivated'
            });
        }

        super.onSubmitHandler(ev);
    }
}

function initRejectScorecardForm() {
    document.querySelectorAll(selector.base).forEach((element) => {
        new RejectScorecardForm(element);
    });
}

initRejectScorecardForm();